import loadable from '@loadable/component';

import { fetchPayment } from '@/actions';

const PaymentPage = loadable(() => import('@/components/PaymentPage'));
const SuccessPage = loadable(() => import('@/components/SuccessPage'));
const ErrorPage = loadable(() => import('@/components/ErrorPage'));

const routes = [
  {
    id: 'payment',
    path: [
      `/:crmLeadId([0-9]{1,}):dgoCrmLeadId(.[0-9]{1,})?-:orderNumber([a-zA-Z0-9_]{1,})`,
    ],
    strict: true,
    exact: true,
    sensitive: true,
    component: PaymentPage,
    props: {
      loadData: async (dispatch, props, options) => {
        await Promise.all([dispatch(fetchPayment(props, options))]);
      },
    },
  },
  {
    id: 'success',
    path: [`/success`],
    strict: true,
    exact: true,
    sensitive: true,
    component: SuccessPage,
  },
  {
    id: 'notFound',
    strict: true,
    exact: true,
    sensitive: true,
    component: ErrorPage,
  },
];

export default routes;
